<template>
  <Dialog v-model="visible">
    <div class="no-dice-dialog">
      <div class="title">{{ $t('monopoly.noDiceTitle') }}</div>
      <div class="tip-line">
        <i18n-t keypath="monopoly.noDiceTip1" tag="span">
          <template #amount>
            <span class="hl">100</span>
          </template>
          <template #dice>
            <span class="hl">{{ $t('monopoly.noDiceNormal') }}</span>
          </template>
        </i18n-t>
      </div>
      <div class="tip-line">
        <i18n-t keypath="monopoly.noDiceTip2" tag="span">
          <template #amount>
            <span class="hl">1000</span>
          </template>
          <template #dice>
            <span class="hl">{{ $t('monopoly.noDiceUniversal') }}</span>
          </template>
        </i18n-t>
      </div>
      <Btn type="blue" class="go-btn" @click="handleGoRecharge">
        {{ $t('monopoly.noDiceGoRecharge') }}
      </Btn>
    </div>
  </Dialog>
</template>

<script setup>
import { computed, defineProps, defineEmits } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import Dialog from '../Dialog/index.vue'
import Btn from '../Btn/index.vue'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['update:modelValue'])
const router = useRouter()
const store = useStore()

const visible = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val),
})

const handleGoRecharge = () => {
  visible.value = false
  const uid = store.state.actUserInfo?.uid
  const resolved = router.resolve({
    name: 'Payment',
    query: uid ? { uid } : {},
  })
  window.open(resolved.href, '_blank')
}
</script>

<style lang="less" scoped>
.no-dice-dialog {
  width: 100%;
  text-align: center;
  color: #1a2b5c;
  padding: 20px 10px 10px;
  box-sizing: border-box;
}

.title {
  font-size: 36px;
  font-weight: bold;
  margin-bottom: 28px;
  color: #1a2b5c;
}

.tip-line {
  font-size: 26px;
  line-height: 1.6;
  font-weight: 600;
  margin-bottom: 10px;
}

.hl {
  color: #e89a2e;
  font-weight: bold;
}

.go-btn {
  margin: 36px auto 0;
}
</style>
